import React, { Component } from 'react';
import './style/home.css';
import './style/normalize.css';
import Imagem38 from './images/Imagem 38.png';
//import logo_correios_menu from './images/logo-correios-menu.png';
import anuncio from './images/anuncio.png';
import anuncio1 from './images/Banners/1.png';
import anuncio2 from './images/Banners/2.png';
import anuncio3 from './images/Banners/3.png';
import anuncio5 from './images/Banners/5.png';
import anuncio6 from './images/Banners/6.png';
import cifao from './images/cifão.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
    Redirect,
    Link
} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Menu from './Components/Menu';
import Plano from './Components/Plano';
import History from './Components/History';
import Consumption from './Components/Consumption/Consumption';
import { transactionID } from "./services/helpers";
import { AlertPaymentPix } from './Components/Recharge/components/AlertPaymentPix';

class Home extends Component {

    constructor() {
        super();
        let localStorageClientInfo = localStorage.getItem("clientInfo");

        this.state = {
            redirect: false,
            phone: '',
            details: [],
            countMoth: 0,
            textVerMais: "Ver Mais",
            MSISDN: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).number : "",
            accessToken: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).accessToken : "",
            isIntelligentControl: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).isIntelligentControl : false,
            menuOpen: false
        }
    };

    // Source: http://stackoverflow.com/questions/497790

    convert = (d) => {
        return (
            d.constructor === Date ? d :
                d.constructor === Array ? new Date(d[0], d[1], d[2]) :
                    d.constructor === Number ? new Date(d) :
                        d.constructor === String ? new Date(d) :
                            typeof d === "object" ? new Date(d.year, d.month, d.date) :
                                NaN
        );
    }

    topUpHistory = () => {

        if (localStorage.getItem("clientInfo") === null) {
            return false;
        }

        var d = new Date();
        d.setMonth(d.getMonth() + 1);

        let _self = this;

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory`, {
            transactionID: transactionID('AAB'),
            MSISDN: this.state.MSISDN,
            "year": d.getFullYear(),
            "month": d.getMonth()
        }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
            .then(res => {
                if (res.data.code === "P00") {

                    if (res.data.details !== null) {

                        // let oderArray = res.data.details.sort(function(a,b) {
                        //     return (
                        //         isFinite(a.date=_self.convert(a.date).valueOf()) &&
                        //         isFinite(b.date=_self.convert(b.date).valueOf()) ?
                        //         (a.date>b.date)-(a.date<b.date) :
                        //         NaN
                        //     );
                        // });
                        // console.log("teste",oderArray);

                        this.setState({ details: [res.data.details.reverse()] });
                    }
                }
            })
            .catch(res => {
                console.log(res);
                Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao conectar com o servidor",
                    type: 'error'
                });
                this.setState({ redirect: true });
            })
    }


    formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            return "";
        }
    }

    openMenu = () => {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    CheckPlanoInteligente = () => {
        if ((localStorage.getItem("clientInfo") === null))
            return false;

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v1/checkPlanoInteligente`, {
            transactionId: transactionID('AAC'),
            msisdn: (localStorage.getItem("clientInfo") !== null) ? JSON.parse(localStorage.getItem("clientInfo")).number : ""
        }, { headers: { "Authorization": (localStorage.getItem("clientInfo") !== null) ? "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken : "" } })
            .then(res => {
                if (res.data.code == "P00") {
                    this.setState({
                        isIntelligentControl: true
                    })

                }
                else {
                    this.setState({
                        isIntelligentControl: false
                    })
                }

            })
            .catch(res => {
                Swal.fire(
                    'Erro!',
                    "Não foi possível conectar com o servidor!",
                    'error'
                )
                this.setState({ opacity1: false });
            })
    }

    componentDidMount() {
        // this.AccountDetails();
        // this.topUpHistory();
        let _self = this;

        setTimeout(() => {
            _self.CheckPlanoInteligente();
        }, 1000)

    }






    render() {

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false
        };

        let { details, isIntelligentControl } = this.state;

        // console.log(this.props.location.state);
        if ((localStorage.getItem("clientInfo") === null) || (this.state.redirect)) {
            return <Redirect to={{
                pathname: "/"
            }} />
        }
        return (
            <div className={`home realhome ${this.state.menuOpen ? "menuOpen" : ""}`}>

                <Menu />
                <div className="content-home">
                    <div className="top">
                        <i className={`top-icon ${this.state.menuOpen ? "menu-icon-close" : "menu-icon"}`} onClick={this.openMenu}></i>
                    </div>
                    <div className="content-main">
                        {/* <div className="banner-center">
                            <a href="#">
                                <img src={Imagem38} alt="banner"/>
                            </a>
                        </div> */}
                        <div className="container">

                            <div className="content-bottom">
                                <div className="content-bottom-inside">
                                    {isIntelligentControl
                                        ? <div className="slide-left">

                                            <div className="boc-links  cards-is-intelligent-control">
                                                <ul>
                                                    <li className="yellowLi">
                                                        <Link to="/PacoteAdicional#adicional">
                                                            <span>Pacote<br />Adicional</span>
                                                            <span><img src={require("./images/arrow.png")} /></span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/ControleInteligente#troca-plano">
                                                            <span>Troca <br />De Plano</span>
                                                            <span><img src={require("./images/arrow.png")} /></span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/RecargaControleInteligente">
                                                            <span>Recarga</span>
                                                            <span><img src={require("./images/arrow.png")} /></span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        : <div className="slide-left cards-is-not-intelligent-control">

                                            <div className="boc-links">
                                                <ul>
                                                    <li className="card-diferent"><Link to="/ControleInteligente"><img src={require("./images/Controle_inteligente.png")} /></Link></li>

                                                    <div className="d-flex">
                                                        <li><Link to="/recarga" onClick={() => {
                                                            localStorage.removeItem("@pix-data-recharge", JSON.stringify(""));
                                                        }}><span>Recarga</span> <img src={require("./images/arrow.png")} /></Link></li>
                                                         {/* <li>
                                                             <Link to="/PacoteAdicional#adicional" onClick={() => {
                                                            localStorage.removeItem("@pix-data-recharge", JSON.stringify(""));
                                                        }}><span>Pacote adicional</span> <img src={require("./images/arrow.png")} /></Link></li> */}
                                                        <li>
                                                            <Link to="/recarga#troca-plano"><span>Troca De Plano</span> <img src={require("./images/arrow.png")} /></Link>
                                                    </li>
                                                    </div>
                                                  
                                                </ul>
                                            </div>
                                        </div>
                                    }

                                    <div style={{ marginTop: "40px" }}>
                                        <AlertPaymentPix />
                                        <Plano />
                                        <History />
                                    </div>
                                </div>



                                <div className="content-bottom-inside">

                                    <Consumption />


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
